import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import IconButton from 'components/IconButton';
import { txt } from 'libs/i18n';
import { useSwitch } from 'hooks/useSwitch';
import BulkExportDialog from '../../BulkExportDialog';
import toolbarStyles from '../style.module.less';
const MAX_PROJECTS_FOR_EXPORT = 50;
const ExportButton = ({ selectionEmpty, selectedProjects, onComplete, }) => {
    const [openDialog, onOpenDialog, onCloseDialog] = useSwitch();
    const isOverLimit = selectedProjects.length > MAX_PROJECTS_FOR_EXPORT;
    return (_jsxs("div", { children: [_jsx(Tooltip, { title: isOverLimit ? txt('selectUpTo50ItemsForExport') : txt('bulkExport'), children: _jsx("div", { children: _jsx(IconButton, { disabled: selectionEmpty || isOverLimit, onClick: onOpenDialog, className: toolbarStyles.toolbarButton, id: "exportPP", children: _jsx(DownloadOutlined, {}) }) }) }), !selectionEmpty && (_jsx(BulkExportDialog, { selectedProjects: selectedProjects, visible: openDialog, onClose: onCloseDialog, onComplete: () => {
                    onCloseDialog();
                    onComplete();
                } }))] }));
};
export default ExportButton;
